(function () {
    'use strict';

    /*
     * Until we have an actual functioning curriculum information management system, this is as good as it gets.
     * @param {any} $scope
     * @param {any} $q
     * @param {any} capsService
     */
    function controller() {

        const DOM = 'domestic';
        const INT = 'international';
        const LOC = 'location';
        const AUD = 'audience';

        this.findValidLocationForAudience = () => {
            const validLocation = locationButtons.find(e => (e.getAttribute(AUD) || '').includes(this.audience));
            if (validLocation) {
                this.onLocationSelect(validLocation.innerText.trim());
            } else {
                filterValid();
            }
        }

        this.onLocationSelect = location => {
            this.location = location;
            filterValid();
            const cricosElement = document.getElementById('cricos');

            if (cricosElement) {
                cricosElement.style.display = this.location.toLowerCase() === 'online' ? 'none' : 'block';
            }
        }

        this.onAudienceSelect = audience => {
            this.audience = audience.toLowerCase();
            localStorage.setItem('view_pref', this.audience.substring(0, 3));

            filterValid();

            // if the current location isn't available to the selected type, find the first valid
            // it's a bit ugly as it requires getting the node from the dropdown to check the audience
            const currentLocationEl = locationButtons.find(e => e.innerText.trim() === this.location);
            const currentLocationAudience = currentLocationEl ? currentLocationEl.getAttribute(AUD) : null;

            if (currentLocationAudience && !currentLocationAudience.includes(this.audience)) {
                this.findValidLocationForAudience();
            }
        }

        const filterValid = () => {
            filterableElements.forEach(e => {
                const locAttribute = e.getAttribute(LOC);
                const validLoc = !locAttribute || locAttribute.includes(this.location);
                const audAttribute = e.getAttribute(AUD);
                const validAud = !audAttribute || audAttribute.includes(this.audience);

                e.classList[validLoc && validAud ? 'remove' : 'add']('d-none');
                e.classList[validLoc && validAud ? 'add' : 'remove']('pulse');
            });
        }

        const defaultAudienceArray = Array.from(document.querySelectorAll('.program-header--text [audience]'))
            .map(x => x.getAttribute('audience').split(' '))
            .flat()
            .filter((v, i, arr) => arr.indexOf(v) === i);

        const locationDropdownEl = document.getElementById('locationDropdown');
        const locationButtons = locationDropdownEl
            ? Array.from(locationDropdownEl.querySelectorAll('button'))
            : [];
        const offeredAudiences = locationButtons
            .map(b => (b.getAttribute(AUD) || '').split(' '))
            .flat();
        const internationalOffered = offeredAudiences.includes(INT);
        const domesticOffered = offeredAudiences.includes(DOM);

        if (defaultAudienceArray.includes(INT) && document.getElementById('pathways')) {
            const intPathways = pathways.querySelectorAll('[audience*="international"]');
            if (intPathways.length == 0) {
                document.getElementById('pathways-tab').parentElement.setAttribute('audience', 'domestic');
            }
        }

        this.audience = defaultAudienceArray.length == 2 ? DOM : defaultAudienceArray[0] === INT ? INT : DOM;

        if ((localStorage.getItem('view_pref') === 'int' || location.search.includes('view=int')) && internationalOffered) this.audience = INT;
        else if (location.search.includes('view=dom') && domesticOffered) this.audience = DOM;

        if (!offeredAudiences.includes(this.audience)) {
            this.audience = internationalOffered ? INT : DOM;
        }

        const locationElements = document.querySelectorAll('[location]');
        const audienceElements = document.querySelectorAll('[audience]');

        const filterableElements = [...locationElements, ...audienceElements];

        this.findValidLocationForAudience();
    }

    angular.module('Uscapp').controller('Usc.ProgramItem2022.Controller', [controller]);
}());
